import React, { useEffect, useState } from "react";
import JsonData from "../data/data.json";
import { Contact } from "./contact";
import "./Submit.css";

const submissionFormUrl = "https://drive.google.com/file/d/1f01rCwkmyXNauq5beFcfjf_u3-lvaJrh/view";

export const Submit = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <main className="submission-page">
        <section className="submission-hero" aria-labelledby="submission-title">
          <div className="submission-hero__shape submission-hero__shape--top" />
          <div className="submission-hero__shape submission-hero__shape--bottom" />
          <div className="submission-shell submission-hero__content">
            <span className="submission-eyebrow">Annwesha Research Journal</span>
            <h1 id="submission-title">Share your research.</h1>
            <p>
              A clear guide for preparing and submitting original scholarly work
              for consideration by Annwesha.
            </p>
            <a className="submission-button submission-button--light" href={submissionFormUrl} target="_blank" rel="noreferrer">
              <i className="fa fa-download" aria-hidden="true" /> Download submission form
            </a>
          </div>
        </section>

        <section className="submission-content">
          <div className="submission-shell">
            <div className="submission-intro">
              <span className="submission-kicker">Before you submit</span>
              <h2>Original work, thoughtfully prepared</h2>
              <p>
                Annwesha publishes original work that has not been published elsewhere
                and is not under consideration by another publication. Please prepare
                your article online using Avro software, in 12-point type.
              </p>
            </div>

            <div className="submission-guides">
              <article className="submission-card">
                <div className="submission-card__icon"><i className="fa fa-file-text-o" aria-hidden="true" /></div>
                <span className="submission-card__label">01 · Manuscript</span>
                <h3>Prepare your paper</h3>
                <ul>
                  <li>Use a brief, informative title.</li>
                  <li>Keep articles within 2,500–3,000 words.</li>
                  <li>Use Avro Keyboard and Kalpurush font.</li>
                  <li>Format the bibliography in MLA style.</li>
                </ul>
              </article>

              <article className="submission-card">
                <div className="submission-card__icon"><i className="fa fa-user-o" aria-hidden="true" /></div>
                <span className="submission-card__label">02 · Author details</span>
                <h3>Identify your work</h3>
                <ul>
                  <li>Include each author’s name and designation.</li>
                  <li>Add a postal address, email address, and phone number.</li>
                  <li>Submit only your original work.</li>
                  <li>Authors are responsible for avoiding plagiarism.</li>
                </ul>
              </article>

              <article className="submission-card">
                <div className="submission-card__icon"><i className="fa fa-check-square-o" aria-hidden="true" /></div>
                <span className="submission-card__label">03 · Review</span>
                <h3>What happens next</h3>
                <p>
                  The Editor, Editorial Board, and subject experts review each paper.
                  Publication is based on their recommendations, and selection or
                  rejection is communicated by email.
                </p>
                <p className="submission-card__note">Editors may make necessary corrections to accepted articles.</p>
              </article>
            </div>

            <section className="submission-delivery" aria-labelledby="delivery-title">
              <div>
                <span className="submission-kicker">Ready to send?</span>
                <h2 id="delivery-title">Complete your submission</h2>
                <p>Attach your article and completed submission form, then email them to our editorial team.</p>
              </div>
              <div className="submission-delivery__actions">
                <a className="submission-button submission-button--primary" href="mailto:annweshajournal@gmail.com?subject=Article%20Submission%20for%20Annwesha">
                  <i className="fa fa-envelope-o" aria-hidden="true" /> Email your article
                </a>
                <a className="submission-form-link" href={submissionFormUrl} target="_blank" rel="noreferrer">
                  Get the form <i className="fa fa-arrow-right" aria-hidden="true" />
                </a>
              </div>
            </section>
          </div>
        </section>
      </main>
      <Contact data={landingPageData.Contact} />
    </>
  );
};
